export default function MicButton({ isListening, supported, onClick, label = '用說的' }) {
  if (!supported) return null
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={`flex h-[56px] w-[56px] shrink-0 items-center justify-center rounded-full border-4 text-[30px] transition ${
        isListening
          ? 'border-white bg-warn shadow-[0_0_0_8px_rgba(220,38,38,0.35)] animate-pulse'
          : 'border-white bg-safe hover:bg-green-600'
      }`}
    >
      🎙️
    </button>
  )
}
